import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'tic-view-google-map',
  templateUrl: './view-google-map.component.html',
  styleUrls: ['./view-google-map.component.scss']
})
export class ViewGoogleMapComponent {
  hotel: any;
  isFullscreen: boolean=false;
  constructor(private sanitizer: DomSanitizer,@Inject(MAT_DIALOG_DATA) public data: any,public dialogRef: MatDialogRef<ViewGoogleMapComponent>){
    this.hotel = data.hotel;
  } 

   getEmbeddedMapUrl(): SafeResourceUrl {
      const addressStr = `${this.hotel?.address.street}, ${this.hotel?.address.city}, ${this.hotel?.address.country}`;
      const encodedAddress = encodeURIComponent(addressStr);
      const url = `https://www.google.com/maps/embed/v1/place?key=AIzaSyCpOmb-XOzjUonfcSf3ujeNM4B1_1P9yZs&q=${encodedAddress}`;
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }  

    closeDialog(): void {
      this.dialogRef.close();
    }

    toggleFullscreen(): void {
      this.isFullscreen = !this.isFullscreen;
  
      if (this.isFullscreen) {
          // Make the dialog truly fullscreen for all devices
          this.dialogRef.updateSize('100vw', '100vh');
          this.dialogRef.addPanelClass('fullscreen-dialog'); // Adds a fullscreen class for styling adjustments
      } else {
          this.dialogRef.updateSize('80vw', '80vh');
          this.dialogRef.removePanelClass('fullscreen-dialog'); // Removes the fullscreen class when exiting fullscreen
      }
  }
  
}
